import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=30b56362&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b56362",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30b56362')) {
      api.createRecord('30b56362', component.options)
    } else {
      api.reload('30b56362', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=30b56362&scoped=true", function () {
      api.rerender('30b56362', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/Layout.vue"
export default component.exports